import breakPoints from 'helpers/Styles';

const TopBanner = ({ block }) => {
  if (!block) return '';
  const {
    title1,
    title1_color,
    subtitle,
    subtitle_colour,
    image,
    image_mobile,
    logo_icon_one,
    logo_icon_two,
    logo_icon_three,
  } = block.primary;
  const title = title1 ? title1 : null;
  const titleColor = title1_color ? title1_color : null;
  const subTitle = subtitle ? subtitle : null;
  const subTitleColor = subtitle_colour ? subtitle_colour : null;
  const bannerImage = image ? image.url : null;
  const bannerImageMobile = image_mobile ? image_mobile.url : null;
  const iconOne = logo_icon_one ? logo_icon_one.url : null;
  const iconTwo = logo_icon_two ? logo_icon_two.url : null;
  const iconThree = logo_icon_three ? logo_icon_three.url : null;  

  const { items } = block;
  return (
    <>
      <div className='top_banner_slice'>
        <div className='banner_container'>
          <div className='banner_wrapper'>
            <div className='banner_information'>
              <div className='banner'>
                <div className='banner_icons'>
                  {iconOne && (
                    <img draggable='false' src={iconOne} alt='iconOne' />
                  )}
                  {iconTwo && (
                    <img draggable='false' src={iconTwo} alt='iconTwo' />
                  )}
                  {iconThree && (
                    <img draggable='false' src={iconThree} alt='iconThree' />
                  )}
                </div>
                <div className='title'>
                  <h1>{title}</h1>
                  <h2>{subTitle}</h2>
                </div>
                <div className='functions_information'>
                  {items &&
                    items.map((item, index) => (
                      <div key={index} className='function_column'>
                        <div className='icon'>
                          <img
                            draggable='false'
                            src={item.function_icon.url}
                            alt='function_icon'
                          />
                        </div>
                        <div className='description'>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div className='banner_information_bg_image' />
            </div>
          </div>
          <div className='banner_image'></div>
        </div>
      </div>
      {/* <div className="functions_information_mobile">
        {items &&
          items.map((item, index) => (
            <div key={index} className="function_column">
              <div className="icon">
                <img draggable="false"  src={item.function_icon.url} alt="" />
              </div>

              <div className="description">
                <p>{item.description}</p>
              </div>
            </div>
          ))}
      </div> */}
      <style jsx>
        {`
          .top_banner_slice {
            background: #000000;
            overflow-y: hidden;
            position:relative;
          }
          .banner_wrapper{
            position:absolute;
            top:0;
            left:0;
            right:0;
            bottom:0;
            z-index:3;
            height:440px;
            max-width:1440px;
            margin:auto;
            display:flex;
            flex-direction:column:
            justify-content:center;
            padding: 0px 48px;
          }
          .banner_container {
            width:100%
            margin:0px auto;
            position: relative;
            height: 440px;
            display:flex;
            flex-direction:column:
            justify-content:center;
            overflow:hidden;
          }
          .banner_info_wrapper{
            position:relative;
            background-color:red;
            max-width:1440px;
            margin:auto;
          }
          .banner_image {
            background-image: url(${bannerImage});
            background-size: contain;
            background-position:right;
            background-repeat: no-repeat;
            height: 440px;
            width: 100%;
            z-index: 0;
            position:absolute;
          }
          .banner_information {
            position:relative;
            z-index: 1;
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .banner_information .title h1 {
            color: ${titleColor};
            font-family: "big_noodle_titling";
            font-size: 100px;
            letter-spacing: 0;
            line-height: 120px;
            margin: 0;
          }
          .banner_information .title h2 {
            color: ${subTitleColor};
            font-family: "big_noodle_titling";
            font-size: 50px;
            letter-spacing: 0;
            line-height: 40px;
            margin: 0;
            margin-bottom: 30px;
          }

          .functions_information {
            display: flex;
            gap: 16px;
            margin-top:24px;
          }
          .functions_information img {
            height: 40px;
            width: 40px;
          }
          .functions_information p {
            color: #949494;
            font-family: "Roboto-Medium";
            font-size: 13px;
            letter-spacing: 0;
            line-height: 25px;
            margin-left: 12px;
          }
          .function_column {
            display: flex;
            align-items:center;
          }
          @media (min-width: 2560px) {
            .banner_container, .banner_wrapper, .banner_image{
              height: 790px !important;
            }
          }
          @media (min-width: 1920px) {
            .banner_container, .banner_wrapper, .banner_image{
              height: 600px;
            }
          }
          @media  (max-width: ${breakPoints.large}) {
            .banner_container, .banner_wrapper, .banner_image{
              height: 440px;
            }
          }

        
          @media (max-width: 1280px) {
           
            .banner_image{
              background-size:cover;
            }
            .banner_information {
              width: 60%;

            }
          }
         
          @media (max-width: ${breakPoints.medium}) {
            .banner_wrapper{
             padding:0px;
            }
            .banner_information {
              width: 80%;
              margin:auto;
            }
            .banner_image{
              opacity:0.3;
            }
            
          }
          @media (max-width: ${breakPoints.small}) {
            .top_banner_slice {
              display: none;
            }
            .banner_wrapper{
              padding:0px;
              position:absolute;
              height:469px;
              display:grid;
            }
            .banner_container {
              padding: 0px;
              height:440px;
              display:grid;
            }
           
            .banner_information {
              width: 100%;
              margin:0;
              position:relative
              z-index:2;
              background-size: cover;
              background-position: right;
              background-repeat: no-repeat;
              background-color:rgba(0,0,0,0);
            }
            .banner{
              position:absolute;
              top: 0px;
              right: 0px;
              bottom: 0px;
              left: 0px;
              z-index:2;
              padding: 20px 16px 10px 16px;
              height:140px;
            }
            .banner_image{
              opacity:1;
             background-image: url(${bannerImageMobile});
            background-size: cover;
            background-position:center;
            background-repeat: no-repeat;
            background-position:right;
            height:300px;
            width:100%;
            margin-top:140px;
            }
            .banner_information_bg_image{
              position:absolute;
              top: 0px;
              right: 0px;
              bottom: 0px;
              left: 0px;
              filter: blur(24px);
              background-image: url(${bannerImageMobile});
              background-size: cover;
              background-position:left;
              background-repeat: no-repeat;
              opacity:0.5;
              z-index:1;
              height:140px;
            }
            .banner_information .title h1 {
              font-size: 40px;
              line-height: 40px;
              text-align: center;
            }
            .banner_information .title h2 {
              font-size: 20px;
              text-align: center;
              line-height: 35px;
              margin-bottom:0px;
            }
            .functions_information{
              justify-content:center;
              margin-top:0px !important;
            }

            .functions_information img {
              height: 24px;
              width: 24px;
            }
            .functions_information p {
              font-size: 10px;
              line-height:16px;
              margin-left: 8px;
              margin-top: 0;
            }
            .function_column {
              display: flex;
              align-items: center;
            }
          }
        `}
      </style>
    </>
  );
};

export default TopBanner;
